import { useGetIUserInformation } from 'src/hooks';
import { HolidayTable } from 'src/components';

export const Holidays = () => {
    const { IUser } = useGetIUserInformation();
    return <>{IUser.id && <HolidayTable userId={IUser.id} />}</>;
};
